import { TAPPAY_SDK_TPDIRECT, GOOGLE_PAY_SDK } from "./Constants/URL";
import { MAX_POINTS_NUMBER } from './Constants/Constants'
import { getAcApiUrl } from "./helper";
import axios from "../utils/axios_interceptor"

export const getTapPayConfig = () => {
  return {
    appId:
      (typeof window === "undefined" ? process.env : window?.appConfig || {})
        .TPAY_APPID || 11948,
    appKey:
      (typeof window === "undefined" ? process.env : window?.appConfig || {})
        .TPAY_APPKEY ||
      "app_kqrG9j5XsKMSZzWvF1jNjQccSGRkSEDzrBvvXoXmYUhTolWt1dZRyWi2rWgA",
    env:
      (typeof window === "undefined" ? process.env : window?.appConfig || {})
        .TPAY_ENV || "sandbox",
  };
};

export function getTPDirect() {
  return new Promise((resolve, reject) => {
    if (typeof window.TPDirect !== "undefined") {
      return resolve(window.TPDirect);
    } else {
      // Load TapPay SDK
      const tapPaySDK = window.document.createElement("script");
      tapPaySDK.src = TAPPAY_SDK_TPDIRECT;
      tapPaySDK.async = true;
      tapPaySDK.onload = () => {
        if (typeof window.TPDirect !== "undefined") {
          resolve(window.TPDirect);
        } else {
          reject(new Error("failed to load TapPay sdk"));
        }
      };
      tapPaySDK.onerror = reject;
      window.document.body.appendChild(tapPaySDK);

      // Load Google Pay SDK
      const googlePaySDK = window.document.createElement("script");
      googlePaySDK.async = true;
      googlePaySDK.onload = () => { };
      googlePaySDK.src = GOOGLE_PAY_SDK;
      googlePaySDK.onerror = reject;
      window.document.body.appendChild(googlePaySDK);
    }
  });
}

export const setupTPDirectSDK = (TPDirect) => {
  const { appId, appKey, env } = getTapPayConfig();
  TPDirect.setupSDK(appId, appKey, env);
};

export const newCardSetupWithCVV = (TPDirect) => {
  console.log("[newCardSetupWithCVV]");
  try {
    TPDirect.card.setup({
      fields: {
        number: {
          element: document.getElementById("new-card-number"),
          placeholder: "**** **** **** ****",
        },
        expirationDate: {
          element: document.getElementById("new-expiration-date"),
          placeholder: "MM / YY",
        },
        ccv: {
          element: document.getElementById("new-ccv"),
          placeholder: "***",
        },
      },
      styles: {
        // Style all elements
        'input': {
          'font-size': '16px'
        },
      },
    });
  } catch (err) {
    console.log("[newCardSetupWithCVV] >> [Exception]", err);
  }
};

export const getCSFrontendMsg = async (msgCode) => {
  const apiUrl = getAcApiUrl();
  const res = await axios({
    method: 'post',
    url: `${apiUrl}/anon/getCSMessage`,
    data: {
      code: msgCode
    },
  });

  if (res?.data)
    return res.data;

  return { message: '', messageType: '' };
}

export const getErrorMessageArray = async (errors) => {
  try {
    if (errors && errors.length > 0) {
      await Promise.allSettled(errors.map(async (item) => {
        const data = await getCSFrontendMsg(item.errorCode);
        item.errorMessage = data?.message;
        return item;
      }))
      return errors
    }
  } catch (error) {
    console.log('[geterrorMessageArray]', error);
  }
}
// 处理移动电话 格式 0928-856001
export const formatMobilePhone = phoneNumber => {
  if (!phoneNumber) return;
  let Tel = phoneNumber?.slice(0, 4) + "-" + phoneNumber?.slice(4);
  return Tel;
};
// 处理室内电话 格式 （020）7734-8299
export const formatIndoorTelePhone = (telRegionCode, telNumber) => {
  if (!telRegionCode && !telNumber) return;
  let Tel = `(${telRegionCode}) ${telNumber}`;
  return Tel;
};

//格式化金额函数
export const formatMoney = money => {
  let moneyValue = money;
  if (money < 0) {
    money = -money;
  }
  let num = (money || 0).toString(),
    result = '';
  while (num.length > 3) {
    result = ',' + num.slice(-3) + result;
    num = num.slice(0, num.length - 3);
  }
  if (num) {
    result = num + result;
  }
  if (moneyValue < 0) {
    return '-$ ' + result;
  } else {
    return ' $ ' + result;
  }
};
//数字转换为汉字
export const formatConvertToChinaNum = (num) => {
  let arr1 = new Array('零', '一', '二', '三', '四', '五', '六', '七', '八', '九');
  let arr2 = new Array('', '十', '百', '千', '万', '十', '百', '千', '亿', '十', '百', '千', '万', '十', '百', '千', '亿');
  if (!num || isNaN(num)) {
    return "零";
  }
  let english = num.toString().split("")
  let result = "";
  for (let i = 0; i < english.length; i++) {
    let des_i = english.length - 1 - i;//倒序排列设值        
    result = arr2[i] + result;
    let arr1_index = english[des_i];
    result = arr1[arr1_index] + result;
  }
  result = result.replace(/零(千|百|十)/g, '零').replace(/十零/g, '十');
  result = result.replace(/零+/g, '零');
  result = result.replace(/零亿/g, '亿').replace(/零万/g, '万');
  result = result.replace(/亿万/g, '亿');
  result = result.replace(/零+$/, '')
  result = result.replace(/^一十/g, '十');

  return result;
}
//日历筛选日期
export const formatOrderTime = time => {
  let Time = time.replace(/\//g, '-');
  return Time;
};

/**
 * 获取上级列表中第一个满足条件的键值。
 * 
 * @param {Array} upLevelList - 上级列表，包含多个对象。
 * @param {string} key - 要获取的键名。
 * @returns {string} - 返回第一个满足条件的对象的键值，如果没有满足条件的对象，则返回空字符串。
 * 
 * @example
 * const result = getUpLevelkey([{ primaryFlag: true, type: 'M', value: 'example' }], 'value');
 * console.log(result); // 输出: 'example'
 */
export const getUpLevelkey = (upLevelList, key) => {
  try {
    if (upLevelList && upLevelList.length > 0) {
      return upLevelList.filter((item) => item?.primaryFlag && item?.type === 'M')?.[0]?.[key];
    }
    return ""
  } catch (error) {
    console.log('getUpLevelkey >> catch:', error);
    return ""
  }
}


/**
 * 根据价格属性获取价格显示名称
 * @param {Array} attribute - 价格属性数组,格式为 [min, max]
 * @returns {string} 格式化后的价格范围字符串,如 "100 - 200點" 或 "2000點以上"
 * @example
 * getPriceName([100, 200]) // 返回 "100 - 200 點"
 * getPriceName([2001, 99999]) // 返回 "2000 點以上" 
 */
export const getPriceName = (attribute) => {
  try {
    if (attribute && attribute.length > 0 && attribute[1]) {
      const price = `${attribute[1]}`.replace(/\,/g, '');
      if (Number(price) == MAX_POINTS_NUMBER) {
        return `2000點以上`
      }
      return `${attribute?.join(' - ')}點`
    } else {
      return ""
    }
  } catch (error) {
    console.log('getPriceName >> catch:', error);
  }
}